import {
    Autocomplete,
    FormControl,
    InputLabel,
    Select,
    TextField,
    Grid,
    MenuItem
  } from '@mui/material'
  import React from 'react'
  
  const Cyanosis = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
       <FormControl fullWidth>
        <InputLabel>Cyanosis</InputLabel>
        <Select
          value={moduleValues?.['Cyanosis'] ?? ''}
          onChange={(e) =>setModuleValues(prev => ({...prev, ['Cyanosis']: e.target.value}))
          }
          label="Cyanosis"
        >
          <MenuItem value="No Cyanosis">No Cyanosis</MenuItem>
          <MenuItem value="Peripheral Cyanosis">Peripheral Cyanosis</MenuItem>
          <MenuItem value="Central Cyanosis">Central Cyanosis</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  )
  
  export default Cyanosis
  